import __request__ from "routing/request";
export function total(requestOptions) {
  return __request__("GET", "/system/throughput", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
